import React from 'react';

export class FormSubmit extends React.Component {

    render() {
        const {
            col,
            disabled,
            label,
        } = this.props;

        return (
            <div className={col}>
                <button
                    type="submit"
                    test-id="form-submit"
                    className="btn btn-lg btn-block btn-primary waves-effect form-btn"
                    disabled={disabled}
                    children={label.toUpperCase()}
                />
            </div>
        );
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/FormSubmit.jsx